import React from "react";
import "./Testimonials.css";

const testimonials = [
  { name: "Emily R.", text: "Fast, reliable, and perfect cleaning every time!" },
  { name: "Michael B.", text: "Pickup and delivery made my life easier!" },
  { name: "Sarah T.", text: "Great quality and friendly service." }
];

export default function Testimonials() {
  return (
    <section className="testimonials-section">
      <h2>What Our Customers Say</h2>
      <div className="testimonial-cards">
        {testimonials.map((t, i) => (
          <div key={i} className="testimonial-card">
            <p>"{t.text}"</p>
            <h4>– {t.name}</h4>
          </div>
        ))}
      </div>
    </section>
  );
}
